import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import './Age.css';

const AgeAndWeight = ({ updateUserData, userData }) => {
    const navigate = useNavigate();
    const [age, setAge] = useState(userData.age);
    const [weight, setWeight] = useState(userData.weight);
    const [height, setHeight] = useState(userData.height);

    const handleNext = () => {
        updateUserData({ age, weight, height });
        navigate('/fitnessgoal');
    };

    return (
        <div className="a1">
            <div className="header1">Enter Your Details</div>
            <div className="form-container1">
                <div className="slider-container">
                    <label className="slider-label">Age:</label>
                    <input
                        type="range"
                        min="0"
                        max="100"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        className="slider"
                        step="1"
                    />
                    <div className="value-display">{age} years</div>
                </div>
                <div className="slider-container">
                    <label className="slider-label">Weight (kg):</label>
                    <input
                        type="range"
                        min="30"
                        max="200"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        className="slider"
                        step="1"
                    />
                    <div className="value-display">{weight} kg</div>
                </div>
                <div className="slider-container">
                    <label className="slider-label">Height (feet):</label>
                    <input
                        type="range"
                        min="4.0"
                        max="7.0"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="slider"
                        step="0.1"
                    />
                    <div className="value-display">{height} feet</div>
                </div>
            </div>
            <div className="r2">
            <div className="action-container">
                <button onClick={() => navigate('/')} className="action-button back-buttonn">Back</button>
                <button onClick={handleNext} className="action-button next-button">Next</button>
            </div>
            </div>
        </div>
    );
};

export default AgeAndWeight;
